
import reactWrapper from "@harbor/elements/utils/react/wrapper";
import { PropTypes } from "prop-types";
import { useI18n } from "../../i18n/useI18n";
import { setTableDensity, setToggledColumns,hiddenColumns } from "../../utils/table";

const [
    HbrCheckbox,
    HbrCheckboxGroup,
    HbrDrawer,
    HbrMenuDivider,
    HbrRadio,
    HbrRadioGroup,
] = reactWrapper(["hbr-checkbox", "hbr-checkbox-group", "hbr-drawer", "hbr-menu-divider", "hbr-radio", "hbr-radio-group"]);

export const SettingsDrawer = ({ tableStore, localStorageName, defaultToggles,dataTestid }) => {
    const { tCommon } = useI18n('common');
    const { columns, settingsOpen, toggleableColumns, size } = tableStore.getState();
    const columnsHook = tableStore.getHook("columns");

    return (
        <HbrDrawer
            id="settings-drawer"
            label={tCommon('tableSettings')}
            size="small"
            open={settingsOpen}
            overlay={true}
            onHbr-hide={(e) => {
                if (e.target.id === "settings-drawer")
                    tableStore.setState({ settingsOpen: false });
            }}
            onHbr-overlay-dismiss={(event) => {
                event.preventDefault();
            }}
        >
            <div className="hbr-css__text-primary-sm-semibold"> {tCommon('tableDensity')}</div>
            <HbrRadioGroup
                direction="column"
                checked
                onHbr-change={(e) => {
                    if (e.target.value != size) {
                        setTableDensity(e.target.value, localStorageName);
                    }
                    tableStore.setState({ size: e.target.value });
                }}
            >
                {["compact", "comfy", "spacious"].map((size) => (
                    <HbrRadio
                        data-testid={`size-${size}`}
                        value={size}
                        key={size}
                        checked={tableStore.getState().size === size}
                    >
                        {size.charAt(0).toUpperCase() + size.slice(1)}
                    </HbrRadio>
                ))}
            </HbrRadioGroup>

            <HbrMenuDivider style={{ "--margin": "16px 0" }} />
            <div className="hbr-css__text-primary-sm-semibold">{tCommon('tableCol')}</div>
            <div className="hbr-css__text-secondary-sm">
                {tCommon('tableSelect')}
            </div>
            <HbrCheckboxGroup direction="column">
                {toggleableColumns
                .filter(col => !hiddenColumns[dataTestid]?.ids.includes(col.id))
                .map((col) => {
                    if (!col.name) return null;
                    const visibleColumnIds = columns.map((column) => column.id);
                    return (
                        <HbrCheckbox
                            key={col.id}
                            checked={visibleColumnIds.includes(col.id)}
                            value={col.id}
                            data-testid={`checkbox-${col.prop}`}
                            onHbr-change={(e) => {
                                setToggledColumns(e.target, localStorageName, defaultToggles);
                                columnsHook.toggle(col.id, e.target.checked);
                            }}
                        >
                            {col.name}
                        </HbrCheckbox>
                    );
                })}
            </HbrCheckboxGroup>
        </HbrDrawer>
    );
}

SettingsDrawer.propTypes = {
    tableStore: PropTypes.object.isRequired,
    localStorageName: PropTypes.string,
    defaultToggles: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    dataTestid : PropTypes.string
};
export default SettingsDrawer;
